import { classNames } from 'src/helpers/utilities'

interface NfdTagInterface {
  label: string
  capitalize?: boolean
  margin?: boolean
  className?: string
}

export type NfdTagColors = 'gray' | 'blue' | 'green' | 'yellow' | 'red'

export type NfdTag = (
  | {
      color: NfdTagColors
      brand?: never
    }
  | {
      color?: never
      brand: boolean
    }
) &
  NfdTagInterface

export const ResultTag = ({
  label,
  capitalize = false,
  margin = false,
  color,
  brand,
  className = ''
}: NfdTag) => {
  const colors = {
    gray: 'bg-gray-100 text-gray-800',
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    yellow: 'bg-amber-100 text-amber-800',
    red: 'bg-red-100 text-red-800'
  }

  const tagClasses = classNames(
    'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
    brand ? 'bg-brand-500 text-white font-bold' : '',
    color ? colors[color] : '',
    capitalize ? 'capitalize' : '',
    margin ? 'mr-2' : '',
    className
  )

  return <span className={tagClasses}>{label}</span>
}

interface ResultTagsProps {
  tags: NfdTag[]
  limit?: number
  tagClassName?: string
}

export const ResultTags = ({ tags, limit = 0, tagClassName = '' }: ResultTagsProps) => (
  <>
    {tags.map((tag, i) => {
      if (limit && i >= limit) {
        return null
      }

      return <ResultTag key={tag.label} margin className={tagClassName} {...tag} />
    })}
  </>
)
